import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import FavoritingHeart from '@components/Shared/Favoriting/FavoritingHeart';
import { modelNameTransformer } from 'pubweb-smokey/dist/utils/modelNameTransformer';
import Button from '@components/Shared/Buttons/Button';
import { StickyNavStyles } from './StickyNav.styled';
import { DXFavoritesContext } from '@contexts/DXFavoritesContext';
import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';

const StickyNav = ({
  homeDetails,
  onFindRetailerClick,
  onFeaturesClick,
  onScheduleVisitClick,
  onLearnMoreClick,
}) => {
  const isOnLand = homeDetails.isOnLand;
  const favoritesContext = useContext(DXFavoritesContext);

  return (
    <StickyNavStyles>
      <div>
        <div className="favoriting-heart-container">
          <FavoritingHeart
            isFavorited={
              !!favoritesContext.state.favoriteModels?.filter(
                (faveModels) =>
                  faveModels.modelNumber === homeDetails.modelNumber
              )[0]
            }
            onClick={() => {
              favoritesContext.actions.toggleFavoriteModel(
                homeDetails.modelNumber
              );
              pushGTMEvent('clickFavoritesHeart');
            }}
          />
        </div>
        <div className="sticky-description">
          {modelNameTransformer(homeDetails.modelDescription)}
        </div>

        {homeDetails.tags && homeDetails.tags.length > 0 && (
          <div className="sticky-links">
            <a
              onClick={() => {
                onFeaturesClick();
                pushGTMEvent('featuresClick');
              }}
            >
              Features
            </a>
          </div>
        )}

        <div className="sticky-buttons">
          {!isOnLand && (
            <Button
              automationId="find-retailer-click"
              className="find-retailer-button"
              isCompact={true}
              onClick={onFindRetailerClick}
            >
              Find A Retailer
            </Button>
          )}
          {isOnLand && (
            <Button
              automationId="learn-more-button"
              className="learn-more-button"
              isCompact={true}
              onClick={onLearnMoreClick}
            >
              Learn More
            </Button>
          )}
          <Button
            automationId="schedule-visit-click"
            className="schedule-vsit-button"
            isCompact={true}
            onClick={onScheduleVisitClick}
          >
            Request Info
          </Button>
        </div>
      </div>
    </StickyNavStyles>
  );
};

StickyNav.propTypes = {
  homeDetails: PropTypes.shape({
    modelDescription: PropTypes.any,
    modelNumber: PropTypes.any,
    tags: PropTypes.any,
    isOnLand: PropTypes.bool,
  }),
  onFeaturesClick: PropTypes.func,
  onFindRetailerClick: PropTypes.any,
  onScheduleVisitClick: PropTypes.func,
  onLearnMoreClick: PropTypes.func,
};

export default StickyNav;
